import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, inject, output, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SETTINGS_CONFIRMATION } from './settings-confirm.types';

@Component({
  selector: 'app-settings-confirm-dialog',
  imports: [A11yModule, IconComponent],
  templateUrl: './settings-confirm-dialog.component.html',
  styleUrl: './settings-kit.less',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsConfirmDialogComponent {
  public readonly confirmation = inject(SETTINGS_CONFIRMATION);
  public readonly cancel = output<void>();
  public readonly confirm = output<void>();
}
